module.exports = __webpack_public_path__ + "static/img/podkladovy_obrazek.4df1ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/podkladovy_obrazek.jpg
// module id = UYG4
// module chunks = 1